import { Textarea, Label } from '@creanizer/ui'
import type { CharacterInterpersonalPatterns } from '@creanizer/types'

interface InterpersonalPatternsEditorProps {
  interpersonalPatterns: CharacterInterpersonalPatterns
  onChange: (interpersonalPatterns: CharacterInterpersonalPatterns) => void
}

export function InterpersonalPatternsEditor({
  interpersonalPatterns,
  onChange
}: InterpersonalPatternsEditorProps) {
  const handleChange = (field: keyof CharacterInterpersonalPatterns, value: string) => {
    onChange({
      ...interpersonalPatterns,
      [field]: value
    })
  }

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="firstMeetingBehavior">初対面の人への接し方</Label>
        <Textarea
          id="firstMeetingBehavior"
          value={interpersonalPatterns.firstMeetingBehavior || ''}
          onChange={(e) => handleChange('firstMeetingBehavior', e.target.value)}
          placeholder="例: 人見知りで最初は警戒するが、徐々に打ち解ける"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="trustCriteria">信頼を寄せる相手の共通点</Label>
        <Textarea
          id="trustCriteria"
          value={interpersonalPatterns.trustCriteria || ''}
          onChange={(e) => handleChange('trustCriteria', e.target.value)}
          placeholder="例: 誠実で嘘をつかない人、約束を守る人"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="distanceCriteria">距離を置く相手の特徴</Label>
        <Textarea
          id="distanceCriteria"
          value={interpersonalPatterns.distanceCriteria || ''}
          onChange={(e) => handleChange('distanceCriteria', e.target.value)}
          placeholder="例: 威圧的な態度を取る人、他人を見下す人"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="romanticView">恋愛観・恋愛パターン</Label>
        <Textarea
          id="romanticView"
          value={interpersonalPatterns.romanticView || ''}
          onChange={(e) => handleChange('romanticView', e.target.value)}
          placeholder="例: 奥手で自分から告白できない、時間をかけて信頼関係を築く"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="hierarchyBehavior">上下関係での振る舞い方</Label>
        <Textarea
          id="hierarchyBehavior"
          value={interpersonalPatterns.hierarchyBehavior || ''}
          onChange={(e) => handleChange('hierarchyBehavior', e.target.value)}
          placeholder="例: 目上には敬語を使い従順、部下には面倒見が良い"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="groupPosition">集団での立ち位置</Label>
        <Textarea
          id="groupPosition"
          value={interpersonalPatterns.groupPosition || ''}
          onChange={(e) => handleChange('groupPosition', e.target.value)}
          placeholder="例: 縁の下の力持ち、ムードメーカー、リーダー"
          rows={2}
          className="mt-1"
        />
      </div>
    </div>
  )
}
